<template>
  <div class="goodList">
    <GoodsForm ref="form" :menuData="menuData" @success="getList"/>
    <FilterForm :fields="searchFields" @submit="searchList"/>
    <BatchNumber ref="batchNumber"/>
    <BasicTable
    showSelect
    border
    hasOperate
    customClass="table"
    :tableData="tableData"
    :pageSize="+pageOption.per_page"
    :currentPage="+pageOption.current_page"
    :total="+pageOption.total"
    :loading="loading"
    :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
    :columns="columns"
    @selectChange="selectChange"
    @pageChange="pageChange">
    <template slot="tableOpeate">
      商品列表&emsp;
      <AppButton size="small" type="primary" plain @click="addGoods"><i class="fa fa-plus fa-lg icon" ></i>新增</AppButton>&emsp;
      <AppButton type="primary" plain size="small" @click="batchDelete"><i class="fa fa-trash-o fa-lg icon"></i>批量删除</AppButton>&emsp;
      <AppButton size="small" type="primary" plain @click="loadDataAdd" :disabled="!$store.state.goods.hasSavedData">
        编辑自动保存数据
        <div class="time" v-if="$store.state.goods.time">（最后保存时间：{{$store.state.goods.time.format('MM-DD HH:mm:ss')}}）</div>
      </AppButton>
    </template>
    <template v-slot:describe="{ item }">
      <div class="describe">
        <el-image
      style="height: 40px; width: 50px; margin-right: 8px"
      :src="item.original_img"
      fit="fill"></el-image>{{item.common_name}}({{item.goods_name}})
      <br/>{{item.goods_spec}}（{{item.big_pack}}/{{item.mid_pack}}）</div>
    </template>
    <template v-slot:is_advertising="{ item }">
      <CheckBox :value="!!item.is_advertising" :asyncClick="changeStatus(item, 'is_advertising')"/>
    </template>
    <template v-slot:is_recommend="{ item }">
      <CheckBox :value="!!item.is_recommend" :asyncClick="changeStatus(item, 'is_recommend')"/>
    </template>
    <template v-slot:is_hot="{ item }">
      <CheckBox :value="!!item.is_hot" :asyncClick="changeStatus(item, 'is_hot')"/>
    </template>
    <template v-slot:is_new="{ item }">
      <CheckBox :value="!!item.is_new" :asyncClick="changeStatus(item, 'is_new')"/>
    </template>
    <template v-slot:is_on_sale="{ item }">
      <CheckBox :value="!!item.is_on_sale" :asyncClick="changeStatus(item, 'is_on_sale')"/>
    </template>
    <template v-slot:operate="{ item }">
      <div class="btns">
        <!-- <AppButton size="mini" type="primary" plain >预览</AppButton>
        <AppButton size="mini" type="primary" plain >编辑</AppButton>
        <AppButton size="mini" type="primary" plain >删除</AppButton> -->
        <AppButton type="primary" plain size="small" @click="openBatchNumber(item)">批号</AppButton>
        <el-button icon="el-icon-search" circle size="mini"></el-button>
        <el-button type="primary" icon="el-icon-edit" circle size="mini" @click="edit(item)"></el-button>
        <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="deleteItem(item)"></el-button>
      </div>
    </template>
    </BasicTable>
  </div>
</template>

<script>
import GoodsForm from './formGoodsList.vue';
import { GoodsService } from '../../service/goods.service';
import BatchNumber from './batchNumber.vue';
import { MessageBox } from 'element-ui';
import { copyArrParam } from '../../utils/index';
const whetherOptions = [ { label: '是', value: 1 }, { label: '否', value: 0 }];
const searchFields = [
  { name: '药品名称', key: 'keywords', type: 'input' },
  { name: '厂商', key: 'manufacturer_id', type: 'select' },
  { name: '广告', key: 'is_advertising', type: 'select', options: whetherOptions },
  { name: '推荐', key: 'is_recommend', type: 'select', options: whetherOptions },
  { name: '热卖', key: 'is_hot', type: 'select', options: whetherOptions },
  { name: '新品', key: 'is_new', type: 'select', options: whetherOptions },
  { name: '上架', key: 'is_on_sale', type: 'select', options: whetherOptions },
  { name: '剂型', key: 'dosage_form', type: 'select', options: whetherOptions },
  { name: '处方类型', key: 'medicine_type', type: 'select', options: whetherOptions },
  { name: '中药类型', key: 'cn_medicine', type: 'select', options: whetherOptions },
  { name: '分类', key: 'cat_id', type: 'cascader', showAllLevels: false, options: [ { label: '测试', value: '23' }], props: { emitPath: false,  children: 'sub', label: 'name', value: 'id' }, span: 6  },
  { name: '品牌', key: 'brand_id', type: 'select' },
  { name: '医保类型', key: 'healthcare_type', type: 'select' },
];
const columns = [
  { name: '商品编号', key: 'goods_code', width: 60 },
  { name: '药品名称/规格/大包/小包', key: 'describe', type: 'custom' },
  { name: '药品分类', key: 'cat_name' },
  { name: '零售价', key: 'market_price'  },
  { name: '生产厂商', key: 'manufacturer_name' },
  { name: '库存', key: 'store_count', width: 80 },
  { name: '广告', key: 'is_advertising', width: 60, type: 'custom' },
  { name: '推荐', key: 'is_recommend', width: 60, type: 'custom' },
  { name: '热卖', key: 'is_hot', width: 60, type: 'custom' },
  { name: '新品', key: 'is_new', width: 60, type: 'custom' },
  { name: '上下架', key: 'is_on_sale', width: 60, type: 'custom' },
  { name: '操作', key: 'operate', type: 'custom', width: 230 },
];
  export default {
    name: 'goodList',
    components: { GoodsForm, BatchNumber },
    data() {
      return {
        searchFields,
        tableData: [],
        columns,
        menuData: {},
        loading: false,
        searchValues: {},
        selectItems: [],
        pageOption: {
          total: 0,
          current_page: 1,
          per_page: 20,
        }
      }
    },
    created() {
      this.getList();
      this.getMenu();
      this.$store.commit({ type: 'GOODSUPDATESABED'});
    },
    methods: {
      addGoods() {
        this.$refs.form.open('add','', this.menuData);
      },
      async edit(item) {
        const data = await GoodsService.detail(item.goods_id);
        this.$refs.form.open('edit', data, this.menuData);
      },
      loadDataAdd() {
        this.$refs.form.loadCacheOpen();
      },
      async getMenu() {
        const data = await GoodsService.getMenu();
        copyArrParam(data.dosage_form, { label: 'dosageform_name', value: 'id' });
        copyArrParam(data.brands, { label: 'brand_name', value: 'id' });
        copyArrParam(data.manufacturer, { label: 'name', value: 'id' });
        data.cn_medicine = this.getArray(data.cn_medicine)
        data.medicine_type = this.getArray(data.medicine_type)
        data.healthcare_type = this.getArray(data.healthcare_type)
        this.searchFields[10].options = data.category.map(item => {
          item.sub.map(v => delete v.sub);
          return item;
        });
        this.searchFields[11].options = data.brands;
        this.searchFields[12].options = data.healthcare_type;
        this.menuData = data;
        this.searchFields[1].options = data.manufacturer;
        this.searchFields[7].options = data.dosage_form;
        this.searchFields[8].options = data.medicine_type;
        this.searchFields[9].options = data.cn_medicine;
      },
      deleteItem(item) {
        MessageBox.confirm('确定要删除这条这个商品吗？', '删除商品').then(async () => {
          await GoodsService.delete(item.goods_id);
          this.pageChange(1);
        });
      },
      batchDelete() {
        if(!this.selectItems.length) { return ; }
        MessageBox.confirm('确定要删除这条这屑商品吗？', '删除商品').then(async () => {
          await GoodsService.delete(this.selectItems.map(v => v.goods_id).join(','));
          this.pageChange(1);
        });
      },
      openBatchNumber(data) {
        this.$refs.batchNumber.open(data);
      },
      getArray(obj) {
        let array = []
        Object.keys(obj).forEach(function(key){
          array.push({label: obj[key], value: Number(key) })
        })
        return array
      },
      async getList() {
        this.loading = true;
        this.selectItems = [];
        const data = await GoodsService.getList({ rows: this.pageOption.per_page, page: this.pageOption.current_page, ...this.searchValues });
        data.goods_list.data.forEach(item => {
          item.original_img = GoodsService.spliceImg(item.original_img);
        });
        this.loading =false;
        this.tableData = data.goods_list.data;
        this.pageOption = data.goods_list;
      },
      searchList(data) {
        if(data.cat_id === '' || data.cat_id === null){
          delete data.cat_id;
        }
        this.searchValues = data;
        this.getList();
      },
      pageChange(index) {
        this.pageOption.current_page = index;
        this.getList();
      },
      selectChange(items) {
        this.selectItems = items;
      },
      changeStatus(item, type) {
        return async () => {
          await GoodsService.changeGoodsStatus(item.goods_id, type);
          await this.getList();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.btns {
  white-space: nowrap;
}
.describe {
  display: flex;
}
.time {
  // color: #ddd;
  display: inline;
}
</style>